module.exports = __webpack_public_path__ + "img/Voice of the Whanau.025ef70e.png";